export default {
  bind(el) {
    const isStandalone = !!window.navigator.standalone;
    if (!isStandalone) el.setAttribute('target', '_blank');
  },
};



// WEBPACK FOOTER //
// ./src/directives/outer-link.js